import { useInfiniteQuery } from '@tanstack/react-query'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectCreditCardIdFromRoute } from 'src/app/BudgetHistory/redux/budgetHistory.selectors'
import { selectCreditCard } from 'src/app/BudgetOverview/redux/budgetOverview.selectors'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import Box from 'src/components/Box/Box'
import BudgetHistoryTable from 'src/components/BudgetHistoryTable/BudgetHistoryTable'
import {
  budgetRevisionsQueries,
  selectBudgetRevisionListModels,
} from 'src/queries/creditCards/budgetRevisions/budgetRevisions.queries'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

const BudgetHistory: React.FC = () => {
  const creditCardId = useSelector(selectCreditCardIdFromRoute)
  const userId = useSelector(selectUserIdFromState)
  const creditCard = useSelector(selectCreditCard)

  const revisionsQuery = useInfiniteQuery({
    ...budgetRevisionsQueries.list(creditCardId, { limit: 5 }),
    select: selectBudgetRevisionListModels,
  })
  const { fetchNextPage, hasNextPage, isFetchingNextPage } = revisionsQuery

  const fetchMoreRevisions = useCallback((): void => {
    if (hasNextPage && !isFetchingNextPage) {
      void fetchNextPage()
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage])

  return (
    <BackgroundPageContent
      css={css`
        padding: 40px;
      `}
    >
      <Box noPadding>
        <BudgetHistoryTable
          revisions={revisionsQuery.data ?? []}
          userId={userId}
          timezone={creditCard?.timezone}
          currency={creditCard?.currency}
          fetchMoreRevisions={fetchMoreRevisions}
          fullyLoadedRevisions={hasNextPage === false}
          revisionsLoading={revisionsQuery.isFetching}
        />
      </Box>
    </BackgroundPageContent>
  )
}

export default BudgetHistory
